import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { LayoutDashboard, Newspaper, Wallet, User } from 'lucide-react';
import logo from '../../assets/logo.png';

const navItems = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/news', label: 'Insights', icon: Newspaper },
  { to: '/list', label: 'Accounts', icon: Wallet },
  { to: '/user', label: 'Profile', icon: User },
];

function NavIcon({ to, label, icon: Icon, end }) {
  return (
    <NavLink
      to={to}
      end={end}
      title={label}
      aria-label={label}
      className={({ isActive }) =>
        `group relative flex h-11 w-11 items-center justify-center rounded-xl transition-colors duration-200 ${
          isActive
            ? 'bg-accent-600 text-white shadow-glow'
            : 'text-muted hover:bg-elevated hover:text-primary'
        }`
      }
    >
      <Icon className="h-5 w-5" aria-hidden="true" />
      <span className="pointer-events-none absolute left-full ml-3 hidden whitespace-nowrap rounded-lg bg-elevated border border-border px-2.5 py-1 text-xs font-medium text-primary opacity-0 shadow-card transition-opacity duration-150 group-hover:opacity-100 lg:group-hover:block">
        {label}
      </span>
    </NavLink>
  );
}

export default function Sidebar() {
  return (
    <>
      {/* Desktop rail */}
      <nav
        aria-label="Primary"
        className="fixed inset-y-0 left-0 z-30 hidden w-[76px] flex-col items-center border-r border-border bg-surface/80 backdrop-blur-md py-5 lg:flex"
      >
        <Link to="/" aria-label="RapidQuest home" className="mb-8 flex h-10 w-10 items-center justify-center rounded-xl bg-elevated">
          <img src={logo} alt="" className="h-6 w-6 object-contain" width={24} height={24} />
        </Link>

        <div className="flex flex-1 flex-col gap-2">
          {navItems.map((item) => (
            <NavIcon key={item.to} {...item} />
          ))}
        </div>
      </nav>

      {/* Mobile bottom tab bar */}
      <nav
        aria-label="Primary"
        className="fixed inset-x-0 bottom-0 z-30 flex items-center justify-around border-t border-border bg-surface/90 backdrop-blur-md px-2 py-2 lg:hidden"
      >
        {navItems.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            aria-label={label}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 rounded-lg px-3 py-1.5 text-[11px] font-medium transition-colors ${
                isActive ? 'text-accent-600' : 'text-muted'
              }`
            }
          >
            <Icon className="h-5 w-5" aria-hidden="true" />
            {label}
          </NavLink>
        ))}
      </nav>
    </>
  );
}
